import { BookingCanceledBaseStep } from '@luggagehero/features/bookings';

export class BookingCanceledStep extends BookingCanceledBaseStep {}
